// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React, { CSSProperties } from 'react'
import { Select, Spin, Form, DatePicker, TimePicker } from 'antd'
import { connect } from 'react-redux'
import './index.less'
import { Moment } from 'moment';

const options = [
  {
    label: 'Last 24 Hour',
    value: 1
  },
  {
    label: 'Last 7 Days',
    value: 7
  },
  {
    label: 'Last 14 Days',
    value: 14
  },
  {
    label: 'Last 30 Days',
    value: 30
  }
]

interface IGPSTrackerProps {
  visible: boolean
  traceTime: [Moment, Moment]
  updateTraceTime: (traceTime: IGPSTrackerProps['traceTime']) => void
  updateStatusTraceTime: (traceStartTime: number, traceEndTime: number) => void
  fetchAndUpdateDeviceTrace: () => Promise<void>
  fetchAndUpdateDeviceStatuses: () => Promise<void>
  style?: CSSProperties
  loading?: boolean
  deviceId: string
  traces?: any
}

class GPSTracker extends React.Component<IGPSTrackerProps> {
  handleTimeRangeChange = async (traceTime: [Moment, Moment]) => {
    const { updateTraceTime, fetchAndUpdateDeviceTrace, fetchAndUpdateDeviceStatuses } = this.props
    updateTraceTime(traceTime)
    await fetchAndUpdateDeviceTrace()
    await fetchAndUpdateDeviceStatuses()
  }

  geoJsonDownload (gpsTraceData) {
    console.log(gpsTraceData)
    if (!gpsTraceData || !gpsTraceData[0] || gpsTraceData[0].length == 0) return
    const flattenedData = [].concat(...gpsTraceData);
    if (!flattenedData || gpsTraceData.length == 0) return
    const geojson = {
      "type": "FeatureCollection",
      "features": flattenedData.map(({lon, lat, timestamp}) => ({
        "type": "Feature",
        "properties": {timestamp},
        "geometry": {
          "type": "Point",
          "coordinates": [lon, lat]
        }
      }))
    };

    console.log("start download")
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(geojson));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    downloadAnchorNode.setAttribute("download", "gps_trace_data.geojson");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
    console.log("finish download")
  }

  /*
  handleTraceTimeChange = async (traceStartTime: number, traceEndTime: number) => {
    const { updateStatusTraceTime, fetchAndUpdateDeviceStatuses } = this.props
    updateStatusTraceTime(traceStartTime, traceEndTime)
    await fetchAndUpdateDeviceStatuses()
  }
  */

  render () {
    const { visible, traceTime, style = {}, loading, deviceId, traces } = this.props
    if (!visible) {
      return null
    }

    console.log(traces)
    return (
      <div style={style} className='gps-tracker'>
        <div className='header'>GPS Tracker</div>
        <div className='indicator'>
            <p className='gpsIndicator' style={{margin:6}}></p>
            <span>GPS</span>
            <p className='recordingIndicator' style={{margin:6}}></p>
            <span>Recording</span>
            <p className='suspendIndicator' style={{margin:6}}></p>
            <span>Suspend</span>
            <p className='chargingIndicator' style={{margin:6}}></p>
            <span>Charging</span>
        </div>
        <div className='body'>
          <div className='title'>Camera ID</div>
          <span>{deviceId}</span>
          <div className='title'>Time Range</div>
          <Spin spinning={loading}>
            {/* <Select
              size='small'
              value={traceTime}
              onChange={this.handleTimeRangeChange}
              style={{ width: '100%' }}
              options={options}
            /> */}
            <DatePicker.RangePicker
              showTime={{ format: 'HH:mm:ss' }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '100%' }}
              value={traceTime}
              onChange={this.handleTimeRangeChange}
            />
          </Spin>
          <div 
            //className='title' 
            style={{color: 'blue', textDecoration: 'underline', cursor: 'pointer'}} 
            onClick={() => this.geoJsonDownload(traces)}>
            Download results in GeoJson file
          </div>
          {/*
          <div style={{marginTop: 20}}>
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign={'left'}
          >
            <Form.Item label={'Track date'}>
              <DatePicker.RangePicker style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label={'Track time'}>
              <TimePicker.RangePicker style={{ width: '100%' }} use12Hours format={'hh:mm A'} minuteStep={5} />
            </Form.Item>
          </Form>
          </div>
          */}
        </div>
      </div>
    )
  }
}

export default connect(
  ({ gpsTrace, loading }) => ({
    visible: gpsTrace.isGPSTrackerVisible,
    traceTime: gpsTrace.traceTime,
    loading: loading.effects.gpsTrace.fetchAndUpdateDeviceTrace
  }),
  ({ gpsTrace, statusTrace }) => ({
    fetchAndUpdateDeviceTrace: gpsTrace.fetchAndUpdateDeviceTrace,
    fetchAndUpdateDeviceStatuses: statusTrace.fetchAndUpdateDeviceStatuses,
    updateTraceTime: gpsTrace.updateTraceTime
  })
)(GPSTracker)
